import { render, staticRenderFns } from "./CardAnexoLista.vue?vue&type=template&id=71ba4a74&scoped=true&"
import script from "./CardAnexoLista.vue?vue&type=script&lang=js&"
export * from "./CardAnexoLista.vue?vue&type=script&lang=js&"
import style0 from "./CardAnexoLista.vue?vue&type=style&index=0&id=71ba4a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba4a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ba4a74')) {
      api.createRecord('71ba4a74', component.options)
    } else {
      api.reload('71ba4a74', component.options)
    }
    module.hot.accept("./CardAnexoLista.vue?vue&type=template&id=71ba4a74&scoped=true&", function () {
      api.rerender('71ba4a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/anexos/CardAnexoLista.vue"
export default component.exports